import Error from "@components/Error";
import Alert from "@ext/markdown/elements/alert/render/component/Alert";
import { Answer } from "@ext/markdown/elements/answer/render/components/Answer";
import BlockField from "@ext/markdown/elements/blockContentField/render/components/BlockField";
import BlockProperty from "@ext/markdown/elements/blockProperty/render/components/BlockProperty";
import Fence from "@ext/markdown/elements/codeBlockLowlight/render/component/CodeBlock";
import Color from "@ext/markdown/elements/color/render/components/Color";
import Gallery from "@ext/markdown/elements/gallery/render/components/Gallery";
import Highlight from "@ext/markdown/elements/highlight/render/components/Highlight";
import Html from "@ext/markdown/elements/html/render/components/HTML";
import HtmlTag from "@ext/markdown/elements/htmlTag/render/component/HtmlTag";
import InlineImage from "@ext/markdown/elements/inlineImage/render/components/InlineImage";
import InlineProperty from "@ext/markdown/elements/inlineProperty/render/components/InlineProperty";
import BulletList from "@ext/markdown/elements/list/render/BulletList";
import OrderList from "@ext/markdown/elements/list/render/OrderList";
import ReadonlyListItem from "@ext/markdown/elements/list/render/ReadonlyListItem";
import TaskList from "@ext/markdown/elements/list/render/TaskList";
import RenderBlock from "@ext/markdown/elements/md/render/RenderBlock";
import RenderInline from "@ext/markdown/elements/md/render/RenderInline";
import { Question } from "@ext/markdown/elements/question/render/components/Question";
import TableCell from "@ext/markdown/elements/table/render/components/TableCell";
import TableRow from "@ext/markdown/elements/table/render/components/TableRow";
import Unsupported from "@ext/markdown/elements/unsupported/render/component/Unsupported";
import View from "@ext/markdown/elements/view/render/components/View";
import type { ReactNode } from "react";
import Code from "../../../../elements/code/render/component/Code";
import Cut from "../../../../elements/cut/render/component/Cut";
import DiagramData from "../../../../elements/diagrams/component/DiagramData";
import Drawio from "../../../../elements/drawio/render/component/Drawio";
import Fragment from "../../../../elements/fragment/render/components/Fragment";
import FragmentLink from "../../../../elements/fragment-link/render/components/FragmentLink";
import Header from "../../../../elements/heading/render/components/ArticleContentHeader";
import Icon from "../../../../elements/icon/render/components/Icon";
import Image from "../../../../elements/image/render/components/Image";
import Link from "../../../../elements/link/render/components/Link";
import Note from "../../../../elements/note/render/component/Note";
import OpenApi from "../../../../elements/openApi/render/OpenApi";
import Table from "../../../../elements/table/render/components/Table";
import Tab from "../../../../elements/tabs/render/component/Tab";
import Tabs from "../../../../elements/tabs/render/component/Tabs";
import Video from "../../../../elements/video/render/components/Video";

// biome-ignore lint/suspicious/noExplicitAny: dynamic component registry requires any
export default function getComponents(): { [name: string]: (props: any) => ReactNode } {
	return {
		Br: () => <br />,
		Link,
		Color,
		code_block: Fence,
		fragment: Fragment,
		"Fragment-link": FragmentLink,
		Code,
		comment: ({ children }: { children: JSX.Element }) => children,
		Cut,
		icon: Icon,
		"inline-property": InlineProperty,
		"source-comment": () => null,
		"inline-source-comment": () => null,
		"Source-comment": () => null,
		"block-field": BlockField,
		"block-property": BlockProperty,
		questionAnswer: Answer,
		question: Question,
		inlineImage: InlineImage,
		html: Html,
		inlineHtmlTag: HtmlTag,
		blockHtmlTag: HtmlTag,
		blockWithInlineHtmlTag: HtmlTag,
		selfClosingHtmlTag: HtmlTag,
		highlight: Highlight,
		view: View,
		Image,
		Li: ReadonlyListItem,
		listItem: ReadonlyListItem,
		taskItem: ReadonlyListItem,
		bulletList: BulletList,
		taskList: TaskList,
		orderedList: OrderList,
		openapi: OpenApi,
		note: Note,
		Alert,
		Unsupported,
		tabs: Tabs,
		gallery: Gallery,
		tab: Tab,
		Video,
		Heading: Header,
		drawio: Drawio,
		Error,
		table: Table,
		diagrams: DiagramData,
		tableCell: TableCell,
		tableRow: TableRow,
		// biome-ignore lint/style/useNamingConvention: expected
		inlineMd_component: RenderInline,
		blockMd: RenderBlock,
	};
}
